import { Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import React from "react";
import { IControl, InputType } from "../models/control";
import { DynamicControl } from "./dynamic-control";

/**
 * Props interface for the DynamicForm component
 */
type DynamicFormProps = {
  /** Array of form controls to render */
  controls: IControl[];
  /** Optional callback fired when any control value changes */
  onValueChanged?: (control: IControl) => void;
};

/**
 * Main dynamic form component that renders a collection of form controls
 * Uses Material-UI Grid system for responsive layout
 *
 * @param controls - Array of form controls to render
 * @param onValueChanged - Optional callback for value change events
 * @returns JSX element containing the rendered form controls
 */
export const DynamicForm = observer(
  ({ controls, onValueChanged }: DynamicFormProps) => {
    return (
      <Grid container spacing={2}>
        {controls.map(
          (x) =>
            // Only render controls that have a type and are not 'none'
            x.type &&
            x.type !== InputType.none && (
              <React.Fragment key={x.name}>
                <DynamicControl
                  control={x}
                  onValueChanged={onValueChanged}
                ></DynamicControl>
              </React.Fragment>
            )
        )}
      </Grid>
    );
  }
);
